import { Chart, Flex, Grid, Span } from "@goodfill/ui-components";
import { DateTime } from "luxon";
import { AccountBondHolding } from "../../../AccountHolding";
import { createDeptDistributionBarChartConfiguration } from "./createDeptDistributionBarChartConfiguration";
import { createPortfolioDeptDistribution } from "./createPortfolioDeptDistribution";

const barContainerStyle = {
  height: "500px",
  width: "400px",
};

export const PortfolioDeptDistributionComponent = (props: {
  bondHoldings: AccountBondHolding[];
  tradeDate: DateTime;
}) => {
  const debtDistribution = createPortfolioDeptDistribution(props.bondHoldings, props.tradeDate);

  const barChartConfiguration = createDeptDistributionBarChartConfiguration(debtDistribution);

  return (
    <Flex direction="row" items="center" justify="between" verticalMargin={4}>
      <Flex direction="col">
        <Flex direction="row" items="center" justify="between" verticalMargin={4}>
          <Span font="medium" size="xl">
            Rating & Maturity Distribution
          </Span>
        </Flex>

        <Grid cols={2}>
          {barChartConfiguration.data.datasets.map(({ label, backgroundColor }, i) => (
            <Flex direction="row" key={i} items="center" horizontalMargin={4}>
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: backgroundColor as string,
                }}
              />
              <Span font="light">{label}</Span>
            </Flex>
          ))}
        </Grid>
        <div style={barContainerStyle}>
          <Chart configuration={barChartConfiguration} />
        </div>
      </Flex>
    </Flex>
  );
};
